import { lazy } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";

const FaStarOfLife = lazy(() =>
  import("react-icons/fa6").then((module) => ({ default: module.FaStarOfLife }))
);
const RiErrorWarningFill = lazy(() =>
  import("react-icons/ri").then((module) => ({
    default: module.RiErrorWarningFill,
  }))
);

import Button from "../../components/shared/Button";

const Forget = () => {
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Enter an Email Address, it's required"),
    }),
    onSubmit: () => {
      navigate(); // You can add a path here like navigate('/reset-confirmation')
    },
  });

  return (
    <div className="bg-[#F7F7F7] py-10 px-3 flex flex-col gap-4">
      <p className="text-sm">
        Forgot your password? Please enter your email address. You will receive
        a link to create a new password via email.
      </p>
      <form onSubmit={formik.handleSubmit}>
        <div className="mb-5 space-y-2">
          <div className="flex gap-1">
            <label className="font-semibold" htmlFor="email">
              Email
            </label>
            <FaStarOfLife className="text-red-500 text-[7px] mt-1" />
          </div>

          <input
            type="email"
            value={formik.values.email}
            placeholder="Email"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            name="email"
            id="email"
            className="p-2 border-none rounded outline-none w-full"
          />
          {formik.errors.email && formik.touched.email && (
            <div className="text-red-700 bg-red-200 text-sm flex gap-2 p-1 rounded">
              <RiErrorWarningFill className="mt-1" />
              {formik.errors.email}
            </div>
          )}
        </div>
        <Button
          btnBgColor="bg-black hover:bg-gray-600 mt-3 w-auto"
          btnColor="text-white"
          padding="py-3 px-8 w-full mt-5"
          btnText="Reset Password"
          type="submit"
        />
      </form>
    </div>
  );
};

export default Forget;
